import React from "react";

const NUMBER_KEYS = [".", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];

const ProductCatalog = ({
  menu,
  selectedCategory,
  selectedOptionsItem,
  quantityInputRef,
  onCategorySelect,
  onProductSelect,
}) => {
  const appendInput = (value) => {
    quantityInputRef.current.value += value;
  };

  return (
    <div className="col-8 pos-catalog">
      <div className="row pos-catalog-layout">
        <div className="col-3 categories pos-category-list">
          {menu.map((menuCategory) => (
            <div
              key={menuCategory.category}
              className={`category-item ${
                selectedCategory === menuCategory ? "is-selected" : ""
              }`}
              onClick={() => onCategorySelect(menuCategory)}
            >
              {menuCategory.category}
            </div>
          ))}
        </div>

        <div className="col-9 pos-product-workspace">
          <div className="itemler">
            {selectedCategory?.items
              ?.filter((item) => Number(item.active) === 1)
              .map((item) => (
                <div
                  key={item.id}
                  className={`card pos-product-card ${
                    selectedOptionsItem === item ? "is-selected" : ""
                  }`}
                  onClick={() => onProductSelect(item)}
                >
                  <div className="card-body">
                    <h5 className="card-title">{item.name}</h5>
                    <h5 className="card-text">{item.price} TL</h5>
                  </div>
                </div>
              ))}
          </div>

          <div className="pos-quantity-panel">
            <input
              className="form-control pos-quantity-input"
              aria-label="Miktar veya sipariş notu"
              ref={quantityInputRef}
              placeholder="0"
            />
            <div className="numbers">
              {NUMBER_KEYS.map((key) => (
                <div
                  key={key}
                  className="number-item"
                  onClick={() => appendInput(key)}
                >
                  {key}
                </div>
              ))}
              <div
                className="number-item"
                onClick={() => {
                  quantityInputRef.current.value = quantityInputRef.current.value.slice(0, -1);
                }}
              >
                {"<"}
              </div>
              <div
                className="number-item"
                onClick={() => {
                  quantityInputRef.current.value = "";
                }}
              >
                C
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ProductCatalog);
